import React, { Component } from "react";
import { ComboBox, DropdownSkeleton } from "carbon-components-react";
import PropTypes from "prop-types";
import { api } from "../../../helpers/api/api";
import AuditRepository from "../../../helpers/api/AuditRepository";

export default class SectionComboBox extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			items: [],
		};
		this.onChange = this.onChange.bind(this);
		this.repository = new AuditRepository();
	}

	async componentDidMount() {
		this.setState({ loading: true });
		const items = await this.getItems();
		this.setState({ items, loading: false });
	}

	onChange = (selectedItem) => {
		const item = selectedItem ? selectedItem.selectedItem : null;
		this.props.onChange(item);
	};

	getItems = async () => {
		let items = [];

		try {
			items = await this.repository.getSections();
		} catch (error) {
			console.error(error);
			this.props.onError(error);
		}
		return items;
	};

	render() {
		return this.state.loading ? (
			<DropdownSkeleton />
		) : (
			<ComboBox
				id="comboBoxSection"
				disabled={this.state.items < 1 || this.props.disabled}
				placeholder="Choose a Section"
				items={this.state.items}
				onChange={this.onChange}
				shouldFilterItem={({ item, inputValue }) => item.name.toLowerCase().includes(inputValue.toLowerCase()) || item.code.toLowerCase().includes(inputValue.toLowerCase())}
				invalid={this.props.invalid}
				invalidText={this.props.invalidText}
				itemToString={(item) => (item ? item && item.name : "")}
				selectedItem={this.props.selectedItem}
			/>
		);
	}
}

SectionComboBox.propTypes = {
	invalid: PropTypes.bool,
	invalidText: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	onError: PropTypes.func.isRequired,
	selectedItem: PropTypes.object,
	disabled: PropTypes.bool,
};
SectionComboBox.defaultProps = {
	invalid: false,
	invalidText: "",
	selectedItem: null,
	disabled: true,
};
